export default class HeightEqualizer {
	static get FinishEvent() {
		return "height-equalized";
	}

	/**
	 * @param {NodeListOf<HTMLElement>} elements
	 */
	constructor(elements) {
		/**
		 * @type {NodeListOf<HTMLElement>}
		 */
		this.$selection = elements;
		this.timeout = 0;
		this.lastTimeStamp = 0;
		this.refreshLimit = 300;

		if (this.$selection.length > 0) {
			this.equalize()
				.then(() => {
					window.addEventListener("resize", this.onUpdate.bind(this));
				});

		}
	}

	async equalize() {

		this.collectRows()
			.then((result) => {
				const rows = result.rows;
				const maxLines = result.lineIndex;

				for (let i = 0; i < maxLines + 1; i++) {
					const row = rows[i];
					if (row.length > 1) {
						let max = 0;
						for (let i in row) {
							if (row.hasOwnProperty(i)) {
								let $item = row[i];
								let h = $item.offsetHeight;
								if (h > max) {
									max = h;
								}
							}
						}

						row.forEach($item => {
							$item.style.height = `${max}px`;
						});
					}
				}

				this.$selection.forEach(item => {
					item.dispatchEvent(new Event(HeightEqualizer.FinishEvent));
				});
			});

	}

	/**
	 * @return {Promise<{rows:HTMLElement[][], lineIndex:number}>}
	 */
	async collectRows() {
		const rows = [];
		let lineIndex = -1;
		let top = Number.NEGATIVE_INFINITY;

		await this.resetHeights();

		return new Promise(resolve => {
			this.$selection.forEach(
				(item, index) => {
					/**
					 * @type {HTMLElement}
					 */
					let baseEl = item.closest(".equal-height");

					if (baseEl) {
						const itemTop = baseEl.getBoundingClientRect().top;
						const isNewRow = itemTop > top;

						if (isNewRow) {
							lineIndex++;
							top = itemTop;
							rows[lineIndex] = [];
						}

						baseEl.dataset.lineIndex = lineIndex.toString();

						rows[lineIndex].push(item);
					}
				}
			);

			resolve({rows, lineIndex});
		});

	}

	resetHeights() {
		return new Promise(resolve => {
			window.setTimeout(() => {
				this.$selection.forEach(
					(item, index) => {
						item.style.height = null;
					}
				);

				resolve();
			}, 10);
		})
	}

	/**
	 * @param {Event} e
	 */
	onUpdate(e) {
		if (e.timeStamp - this.lastTimeStamp >= this.refreshLimit) {
			window.clearTimeout(this.timeout);
			this.timeout = window.setTimeout(this.equalize.bind(this), 800);
			this.lastTimeStamp = e.timeStamp;
		}

	}
}
